import axios from 'axios'
import { getUserInfo } from './login'

const config = {
    project: 'kj-peki',
    version: '1.0.0',
    userAgent: window.navigator.userAgent,
    opt: '-',
    type: '-',
    func: '-',
    action: '-',
    time: '-',
    page: '-',
    previous: '-',
    data1: '-',
    data2: '-',
    data3: '-',
}

const logger = (params) => {
    const userInfo = getUserInfo()
    axios.get('https://log-blink.cn-beijing.log.aliyuncs.com/logstores/store_www/track', {
        params: {
            APIVersion: '0.6.0',
            ...config,
            opt: userInfo ? userInfo.id : '-',
            time: Date.now(),
            page: window.location.href,
            ...params,
        },
    })
}

export const paperSLS = (paperNo) => {
    logger({
        type: 'paper',
        action: 'open',
        data1: paperNo,
    })
}

export const activityV1SLS = (data) => {
    logger({
        type: 'activityV1',
        ...data,
    })
}

export const errorSLS = (data) => {
    logger({ type: 'error', ...data })
}

